export default function runGazelleRun($log, $rootScope, $window) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  // $log.debug('The Gazelle has started running...');

  // Do Gazelle run work here...
  //rnL10n.setAppServiceBase('uxf', 'portal_service');

  let gazelleVersion = 'unknown';
  /* global __GAZELLE_VERSION__ */
  if (typeof __GAZELLE_VERSION__ !== 'undefined') {
    gazelleVersion = __GAZELLE_VERSION__;
  }
  $log.info('Gazelle version: ' + gazelleVersion);

  logUiRouterEvents();

  // $log.debug('The Gazelle finished running and is tired now.');

  ////////////////

  function logUiRouterEvents() {
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
      $log.debug(`${event.name} fromState: '${fromState.name}' => toState: '${toState.name}'`);
    });
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      $log.debug(`${event.name} fromState: '${fromState.name}' => toState: '${toState.name}'`);
    });
    $rootScope.$on('$stateNotFound', function(event, toState, toParams, fromState, fromParams) {
      $log.warn(`${event.name} fromState: '${fromState.name}' => toState: '${toState.name}'`);
    });
    $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
      $log.error(`${event.name} fromState: '${fromState.name}' => toState: '${toState.name}'`, error);
    });
  }
}
